import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import CoachPageLayout from '../../components/CoachPageLayout/CoachPageLayout';
import StyledButton from '../../components/Common/StyledButton';
import { getPlanInfo } from '../../utils/paymentUtills';
import { SUBSCRIPTION_PLANS } from '../../utils/routes';

export default function PaymentInfo() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const plan = searchParams.get('plan');
  const handleDismiss = () => {
    navigate(SUBSCRIPTION_PLANS);
  };

  let text1: string | undefined;
  let text2: string | undefined;
  if (plan) {
    const texts = getPlanInfo(plan);
    text1 = texts?.text1;
    text2 = texts?.text2;
  } else {
    navigate(SUBSCRIPTION_PLANS);
  }

  return (
    <CoachPageLayout>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: 'transparent',
          padding: '20px',
          borderRadius: '16px',
          justifyContent: 'flex-start',
          alignItems: 'center',
          background: 'linear-gradient(163deg, #FFF 10.13%, #FFF4F0 89.18%)',
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            height: '100%',
            flexDirection: 'column',
            justifyContent: 'center',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              maxWidth: '450px',
              height: '160px',
              gap: '20px',
            }}
          >
            <Box sx={{ alignContent: 'center', textAlign: 'center' }}>
              <Typography variant="bodyBold" textAlign="center">
                {plan ? t('payment.subscriptionInfo') : t('payment.paymentInfo')}
              </Typography>
            </Box>
            <Box sx={{ textAlign: 'center' }}>
              {plan && (
                <Box display="flex" flexDirection="column">
                  <Typography variant="bodyRegular">{text1}</Typography>
                  <Typography variant="bodyRegular">{text2}</Typography>
                </Box>
              )}
              {!plan && (
                <Typography variant="bodyRegular">{t('payment.paymentInfoDesc')}</Typography>
              )}
            </Box>
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              maxWidth: '450px',
              height: '162px',
              gap: '20px',
            }}
          >
            <Box sx={{ alignContent: 'center', textAlign: 'center' }}>
              <Typography variant="bodyBold">{t('payment.paymentProcessingStripe')}</Typography>
            </Box>
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="bodyRegular">
                {t('payment.paymentProcessingStripeDesc')}
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              maxWidth: '450px',
              height: '260px',
              gap: '20px',
            }}
          >
            <Box sx={{ alignContent: 'center', textAlign: 'center' }}>
              <Typography variant="bodyBold">{t('payment.privacyMessage')}</Typography>
            </Box>
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="bodyRegular">{t('payment.privacyMessageDesc')}</Typography>
            </Box>
            <Box
              sx={{
                justifyContent: 'center',
                alignItems: 'center',
                display: 'flex',
                width: '100%',
                paddingTop: '20px',
              }}
            >
              <StyledButton onClick={() => handleDismiss()} paddingX={56} paddingY={12}>
                {t('common.dismiss')}
              </StyledButton>
            </Box>
          </Box>
        </Box>
      </Box>
    </CoachPageLayout>
  );
}
